
<template>
  <div id="content">
    <section id="corp">
      <div class="input_list">
        <ul>
          <li>
              <span class="list_line item_title text_right">
                <label>会社名：</label>
              </span>
              <span class="list_line">
                <label>{{corpForm.corpName}}</label>
              </span>
          </li>
          <li>
              <span class="list_line item_title text_right">
                <label>支店名・営業所名：</label>
              </span>
              <span class="list_line">
                <label>{{corpForm.corpBranchName}}</label>
              </span>
          </li>
          <li>
              <span class="list_line item_title text_right">
                <label>メールアドレス：</label>
              </span>
              <span class="list_line">
                <label>{{corpForm.email}}</label>
              </span>
          </li>
          <li>
              <span class="list_line item_title text_right">
                <label>電話番号：</label>
              </span>
              <span class="list_line">
                <label>{{corpForm.tel}}</label>
              </span>
          </li>
          <li>
              <span class="list_line item_title text_right">
                <label>FAX番号：</label>
              </span>
              <span class="list_line">
                <label>{{corpForm.fax}}</label>
              </span>
          </li>
          <li>
              <span class="list_line item_title text_right">
                <label>郵便番号：</label>
              </span>
              <span class="list_line">
                <label>{{corpForm.postcd}}</label>
              </span>
          </li>
          <li>
              <span class="list_line item_title text_right">
                <label>住所：</label>
              </span>
              <span class="list_line">
                <label>{{corpForm.state}} {{corpForm.city}}</label>
              </span>
          </li>
          <li>
              <span class="list_line item_title text_right">
                <label>以下住所：</label>
              </span>
              <span class="list_line">
                <label>{{corpForm.street}}</label>
              </span>
          </li>
          <li v-if="!isEdit">
              <span class="list_line item_title text_right">
                <label>招待コード：</label>
              </span>
              <span class="list_line">
                <label>{{corpForm.inviteCode}}</label>
              </span>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>

export default {
  name: 'UserConfirm',
  components: {
  },
  props: {
    corpForm: Object,
    isEdit: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  created () {
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/user/CorpConfirm.vue